module.exports = __webpack_public_path__ + "3e689aa7133cfb52649209e2aa29f641.svg";